/**
 * Enumerates all supported inbound redirect integrations.
 * Values match the backend InboundRedirectSourceEnum.
 */
export enum InboundRedirectSourceEnum {
    ACA = 0,
    Clariti = 1,
    OPAL = 2,
    ItemType = 3,
    EPL = 4,
    IMS = 5
}

/**
 * Display labels for InboundRedirectSourceEnum values.
 */
export const InboundRedirectSourceLabels: Record<InboundRedirectSourceEnum, string> = {
    [InboundRedirectSourceEnum.ACA]: 'ACA',
    [InboundRedirectSourceEnum.Clariti]: 'Clariti',
    [InboundRedirectSourceEnum.OPAL]: 'OPAL',
    [InboundRedirectSourceEnum.ItemType]: 'ItemType',
    [InboundRedirectSourceEnum.EPL]: 'EPL',
    [InboundRedirectSourceEnum.IMS]: 'IMS'
};

/**
 * Helper class for InboundRedirectSourceEnum operations.
 */
export class InboundRedirectSourceEnumHelpers {
    /**
     * Get all enum options as an array suitable for dropdowns.
     */
    static getOptions(): { value: number; label: string }[] {
        return Object.keys(InboundRedirectSourceEnum)
            .filter(key => !isNaN(Number(key)))
            .map(key => ({
                value: Number(key),
                label: InboundRedirectSourceLabels[Number(key) as InboundRedirectSourceEnum]
            }));
    }

    /**
     * Get the display label for an enum value.
     */
    static getLabel(value: InboundRedirectSourceEnum | number): string {
        return InboundRedirectSourceLabels[value as InboundRedirectSourceEnum] || 'Unknown';
    }
}
